import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class DoubleOptInApiService {
  constructor(private apiService: ApiService) {}

  saveDoubleOptInStatus(talentId: string, talentEmail: string): Observable<void> {
    const params = new HttpParams()
      .set('talentId', talentId)
      .set('talentEmail', talentEmail);
    return this.apiService.httpWrapper<void>({
      method: 'PUT',
      url: `/api/double-opt-in/confirm`,
      params: params
    });
  }
}
